import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'

const ActivePromo = ({ defaultData: { promotionShortDescription }, removePromotion }) =>
  <Wrapper>
    <Icon asset="tire-promo" width="14px" alt="Promo Icon" />

    <PromoShortDescription>
      {promotionShortDescription}
    </PromoShortDescription>

    <CloseIcon
      asset="close-icon-red"
      width="12px"
      alt="Close Icon"
      onClick={ removePromotion } />
  </Wrapper>

ActivePromo.propTypes = {
  defaultData: PropTypes.shape(),
  removePromotion: PropTypes.func
}

export default ActivePromo

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 5px 7px;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
`

const PromoShortDescription = styled.p`
  margin: 0;
  padding: 0 5px 0 5px;
  font-size: 12px;
  text-transform: uppercase;
`

const CloseIcon = styled(Icon)`
  cursor: pointer;
`
